import styled from "styled-components";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export const StyledCheckboxSection = styled.div`
  padding: 6px 11px;
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 5px;
  display: flex;
`;

export const StyledCheckboxDescription = styled.span`
  padding-left: 9px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: ${TextColorNames.primary};
`;
